import { UserActions } from './user';
import { RefreshPageActions } from './refresh-page';
import { TutorialActions } from './tutorial';
import { User } from '../../types';
import { TutorialState } from '../state';

export const Actions = {
  ...UserActions,
  ...RefreshPageActions,
  ...TutorialActions,
};

interface SetUserDataAction {
  type: UserActions.SET_USER_DATA;
  payload: User;
}

interface SetRefreshPageAction {
  type: RefreshPageActions.SET_REFRESH_PAGE;
}

interface SetTutorialAction {
  type: TutorialActions.SET_TUTORIAL;
  payload: TutorialState;
}

export type ActionType = SetUserDataAction | SetRefreshPageAction | SetTutorialAction;
